import { render, staticRenderFns } from "./HandlerProfileDetails.vue?vue&type=template&id=467a685a"
import script from "./HandlerProfileDetails.vue?vue&type=script&lang=ts"
export * from "./HandlerProfileDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports